<template>
	<div style="width:450px; height:350px;" v-on:keyup.esc="close()">
		<table class="view_tbl">
			<colgroup>
				<col style="" />
				<col style="" />
			</colgroup>
			<tbody>
				<tr>
					<th>Bounce Date</th>
					<td><CustomDatePicker v-model="bounce_date" /></td>
				</tr>
				<tr>
					<th>Fee</th>
					<td><currency-input type="text" v-model.trim="fee" :precision="2" class="tbl_int al_right" /></td>
				</tr>
				<tr>
					<th>Bounce Type</th>
					<td>
						<select class="tbl_select full_int" v-model="bounce_type">
							<option :value="null">Select or Write yourself</option>
							<option value="BOUNCE">Bounced</option>
							<option value="STOP PAYMENT">Stop Payment</option>
							<option value="BANK ACCOUNT CLOSED">Bank Closed Account</option>
						</select>
					</td>
				</tr>
				<tr>
					<th>Write Type</th>
					<td><input type="text" v-model.trim="bounce_type_input" :disabled="bounce_type" class="tbl_int full_int" @focus="$event.target.select()" /></td>
				</tr>
				<!-- <tr>
					<th>Remark</th>
					<td>
						<textarea style="padding:2px;" rows="3" v-model.trim="remark" class="textarea_type"></textarea>
					</td>
				</tr> -->
			</tbody>
		</table>

		<div class="view_bottom_bt" style="padding-top:20px;">
			<a href="javascript:;" type="button" class="search_bt" @click="save()">Save</a>
			<a href="javascript:;" type="button" class="gray_bt" @click="close()">Cancel</a>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiBounceCheck } from '@/api/receipt/index.js';
import { today } from '@/utils/date.js';
import CustomDatePicker from '@/components/common/CustomDatePicker';

export default {
	components: { CustomDatePicker },
	data: function() {
		return {
			fee: 30,
			bounce_type: null,
			bounce_type_input: null,
			bounce_date: today(),
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	props: {
		receipt_no: Number,
		receipt_item_no: Number,
		check_no: String,
		bill_to_code: String,
		bounce_amount: Number,
	},
	methods: {
		close() {
			this.$emit('close');
		},
		async save() {
			if (!this.fee) {
				this.$toast.error('Invalid fee');
				return;
			}

			var remark;
			if (this.bounce_type) remark = this.bounce_type;
			else remark = this.bounce_type_input;

			//console.log(this.receipt_methods);
			const { data } = await apiBounceCheck({
				receipt_no: this.receipt_no,
				receipt_item_no: this.receipt_item_no,
				check_no: this.check_no,
				bounce_amount: this.bounce_amount,
				bill_to_code: this.bill_to_code,
				bounce_date: this.bounce_date,
				fee: this.fee,
				remark: remark,
			});

			if (data.result) {
				this.$toast.success('Bounce processed successfully');
				this.$emit('bounce-call-back', true);
				this.close();
			} else {
				this.$toast.error(data.msg);
			}
		},
	},
	created() {
		this.fee = this.$session.get('profile').bounce_fee;
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
